import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, IconButtonProps, Tooltip } from '@mui/material';

function DeleteButton({
  tooltip = 'Delete',
  placement,
  ...props
}: IconButtonProps & {
  tooltip?: string;
  placement?:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start';
}) {
  return (
    <Tooltip title={tooltip} placement={placement}>
      <IconButton {...props}>
        <DeleteIcon />
      </IconButton>
    </Tooltip>
  );
}
export default DeleteButton;
